<script setup lang="ts">
import { Carousel, Slide } from 'vue3-carousel';
import { inject } from 'vue'

const view = inject("view", "mobile")
const images = [
  {
    img: "slider-image-1.png",
    alt: "Перевод средств"
  },
  {
    img: "slider-image-2.png",
    alt: "Оплата услуг"
  },
  {
    img: "slider-image-3.png",
    alt: "Операции по карте"
  },
  {
    img: "slider-image-4.png",
    alt: "Перевод по номеру"
  },
  {
    img: "slider-image-5.png",
    alt: "Страница оплаты"
  },
  {
    img: "slider-image-6.png",
    alt: "Экран приветствия"
  },
  {
    img: "slider-image-7.png",
    alt: "Витрина продуктов АЭБ"
  },
  {
    img: "slider-image-8.png",
    alt: "Овердрафт"
  },
  {
    img: "slider-image-9.png",
    alt: "Главная"
  },
  {
    img: "slider-image-10.png",
    alt: "Информация по кредиту"
  },
  {
    img: "slider-image-11.png",
    alt: "Оплата по QR"
  },
]
</script>

<template>
 <section class="more screen">
  <h2>И многое другое</h2>
  <Carousel
class="carousel" 
    :items-to-show="view == 'mobile'? 2 : view == 'tablet'? 4: 6" :autoplay="2000" 
    :wrap-around="true" snap-align="center"
    :model-value="5"  
  >
    <template #slides>
      <Slide v-for="image in images" :key="image.alt">
        <img 
          :alt="image.alt"
          :src="'/assets/images/slider-images/'+ image.img" 
        />
      </Slide>
    </template>
  </Carousel>
 </section>
</template>

<style lang="scss" scoped>
.carousel {
  width: 100%;
  margin-top: 120px;

  img {
    max-width: calc(100% - 36px);
    cursor: pointer;
    user-select: none;
  }
}

</style>
